import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Image } from "../../Image/Image/Image";
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import styles from "./SectionOne.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionOne = function SectionOne(_ref) {
  var heading = _ref.heading,
    image = _ref.image,
    button = _ref.button,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? '#fce7cf' : _ref$backgroundColor;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.sectionOne,
    style: {
      backgroundColor: backgroundColor
    },
    children: [(image === null || image === void 0 ? void 0 : image.mobile) && image.desktop && /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: "small",
      children: [/*#__PURE__*/_jsx(Image, _objectSpread({
        className: classnames(styles.image, styles.mobile)
      }, image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
        className: classnames(styles.image, styles.desktop)
      }, image.desktop))]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [heading && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        align: "center",
        className: styles.heading,
        typog: heading.typog,
        ariaLevel: heading.ariaLevel,
        children: heading.text
      }), button && /*#__PURE__*/_jsx(Button, _objectSpread({
        className: styles.button
      }, button))]
    })]
  });
};